<template>
    <!--    eslint-disable -->
    <page-estates-item-finuslugi
        v-bind:estate-data='JSON.parse(`{\u0022id\u0022: 23, \u0022name\u0022: \u0022Офис в Москва\u002DСити (БЦ iCity)\u0022, \u0022status\u0022: \u0022new\u0022, \u0022type\u0022: {\u0022id\u0022: 1, \u0022name\u0022: \u0022Бизнес\u002Dцентр\u0022, \u0022is_active\u0022: true, \u0022icon\u0022: \u0022business\u002Dcenter\u0022}, \u0022investment_types\u0022: [{\u0022id\u0022: 2, \u0022name\u0022: \u0022direct\u0022}], \u0022address\u0022: \u0022Москва, ул. Ермакова Роща, д. 1, стр. 1\u0022, \u0022finance\u0022: {\u0022total_cost\u0022: \u0022265000000.00\u0022, \u0022target_profitability\u0022: \u002217.00\u0022, \u0022current_profitability\u0022: \u00220.0\u0022, \u0022target\u0022: 171800000, \u0022minimum_investment_amount\u0022: 112500, \u0022current_dividend_profitability\u0022: \u00220.0\u0022, \u0022target_dividend_profitability\u0022: \u002210.00\u0022, \u0022cap_rate\u0022: \u00229.00\u0022}, \u0022balance\u0022: \u0022142714000.00\u0022, \u0022url\u0022: \u0022/estate/23/\u0022, \u0022created\u0022: \u00222025\u002D11\u002D24T17:33:39.186376+03:00\u0022, \u0022modified\u0022: \u00222026\u002D03\u002D13T00:20:40.101784+03:00\u0022, \u0022description\u0022: \u0022Готовый офисный блок площадью 296 м2 на 19\u002Dм этаже премиального Бизнес Центра «iCity». Башня расположена в лучшем деловом кластере России «Москва– Сити» и является самым современным БЦ района (ввод в эксплуатацию \u002D 3кв 2025 г.)\u0022, \u0022document\u0022: \u0022https://storage.yandexcloud.net/se\u002Dprod\u002Dmedia/estates/documents/23/iCity__%D0%BC%D0%B5%D0%BC%D0%BE%D1%80%D0%B0%D0%BD%D0%B4%D1%83%D0%BC_3%D0%B8_%D1%80%D0%B0%D1%83%D0%BD%D0%B4_1772620878.pdf\u0022, \u0022document_title\u0022: \u0022Презентация по объекту\u0022, \u0022image\u0022: \u0022https://cdn.simpleestate.ru/images/estates/None/%D0%91%D0%B5%D0%B7_%D0%B7%D0%B0%D0%B3%D0%BE%D0%BB%D0%BE%D0%B2%D0%BA%D0%B0_1763994819.jpg\u0022, \u0022youtube_video\u0022: null, \u0022order\u0022: 0, \u0022is_active\u0022: true, \u0022gba\u0022: 296, \u0022gla\u0022: 296, \u0022occupancy\u0022: 0, \u0022investment_rounds\u0022: [{\u0022is_active\u0022: false, \u0022target\u0022: 86800000, \u0022balance\u0022: \u0022126800000.00\u0022}, {\u0022is_active\u0022: false, \u0022target\u0022: 55000000, \u0022balance\u0022: \u002254789000.00\u0022}, {\u0022is_active\u0022: true, \u0022target\u0022: 30000000, \u0022balance\u0022: \u00221125000.00\u0022}, {\u0022is_active\u0022: false, \u0022target\u0022: 93200000, \u0022balance\u0022: \u00220.00\u0022}], \u0022quarterly_reports\u0022: [], \u0022share_price\u0022: \u002211250.00\u0022, \u0022overage_limit\u0022: \u002210.0\u0022, \u0022can_invest\u0022: true, \u0022current_investment_request_id\u0022: null}`)'
    >
        <plugin-estates-navigable-container-finuslugi inline-template v-bind:estate-id="23">
            <article class="plugin-estates-navigable-container">
                <div class="plugin-estates-navigable-container__content">
                    <div class="plugin-estates-navigable-container__content-item"
                         ref="item0"
                         id="Инвестиционный тезис"
                    >
                        <div class="common-ckeditor">
                            <h1>Инвестиционный тезис</h1>
                        </div>

                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _desktop" style="height: 40px"></div>
                        </plugin-spacer>
                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _mobile" style="height: 20px"></div>
                        </plugin-spacer>

                        <section class="common-columns-36">
                            <section class="common-columns-36__item _common_width_16 _common_offset_0 _sm_width_36 _sm_offset_0">
                                <div class="common-ckeditor">
                                    <h2>Приобретение офиса 296 м2 в новом БЦ «iCity» класса «A» в Москва-Сити</h2>

                                    <p style="text-align: justify;"></p>

                                    <p style="text-align: justify;">Инвестиционный проект по приобретению офисного блока
                                        в БЦ "iCity" является привлекательным за счет: </p>

                                    <ul>
                                        <li>Башня расположена в лучшем деловом кластере России «Москва – Сити» с самым
                                            низким уровнем вакансии – 1%;
                                        </li>
                                        <li>Новое предложение в деловом кластере появится только к 2030 году, что
                                            позитивно скажется на росте ставок аренды на фоне дефицита еще на протяжении
                                            4-5 лет;
                                        </li>
                                        <li>Бизнес центр имеет превосходную транспортную доступность – в 3-5 минутах
                                            ходьбы расположены 2 станции: Шелепиха (МЦК и БКЛ) и Тестовская (МЦД). Также
                                            предусмотрен прямой заезд на парковку БЦ с ТТК;
                                        </li>
                                        <li>На первых этажах предусмотрена большая торговая галерея на 9 800 м2 со всем
                                            необходимым для комфортной работы в офисе: кафе, рестораны, сервисные
                                            службы, спортивные залы и т.д.
                                        </li>
                                    </ul>
                                </div>

                                <plugin-spacer inline-template>
                                    <div class="plugin-spacer _desktop" style="height: 0px"></div>
                                </plugin-spacer>
                                <plugin-spacer inline-template>
                                    <div class="plugin-spacer _mobile" style="height: 20px"></div>
                                </plugin-spacer>
                            </section>
                            <section class="common-columns-36__item _common_width_20 _common_offset_0 _sm_width_36 _sm_offset_0">
                                <plugin-illustration
                                    v-bind:image="'https://cdn.simpleestate.ru/plugins/illustration/%D1%80%D0%B0%D1%81%D0%BF%D0%BE%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5.png'"
                                    v-bind:height-factor="55"
                                >
                                </plugin-illustration>
                            </section>
                        </section>

                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _desktop" style="height: 40px"></div>
                        </plugin-spacer>
                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _mobile" style="height: 20px"></div>
                        </plugin-spacer>

                        <section class="common-columns-36">
                            <section class="common-columns-36__item  _common_width_16 _common_offset_0 _sm_width_36 _sm_offset_0">
                                <div class="common-ckeditor">
                                    <h2>Офис расположен на 19-м этаже в башне "Space&nbspTower" и имеет открытую планировку</h2>
                                    <br />
                                    <h2><strong>О проекте ICity:</strong></h2>
                                    <p>Общая площадь - 230 000 м2</p>
                                    <p>Площадь офисов - 135 833 м2</p>
                                    <p>Год постройки - 2025 </p>
                                    <p>Класс - А/А+ </p>
                                </div>
                                <plugin-spacer inline-template>
                                    <div class="plugin-spacer _desktop" style="height: 0px"></div>
                                </plugin-spacer>
                                <plugin-spacer inline-template>
                                    <div class="plugin-spacer _mobile" style="height: 20px"></div>
                                </plugin-spacer>
                            </section>

                            <section class="common-columns-36__item _common_width_20 _common_offset_0 _sm_width_36 _sm_offset_0">
                                <plugin-illustration
                                    v-bind:image="'https://cdn.simpleestate.ru/plugins/illustration/%D0%9F%D0%BB%D0%B0%D0%BD%D0%B8%D1%80%D0%BE%D0%B2%D0%BA%D0%B0.png'"
                                    v-bind:height-factor="54"
                                >
                                </plugin-illustration>
                            </section>
                        </section>
                    </div>

                    <div class="plugin-estates-navigable-container__content-item"
                         ref="item1"
                         id="Описание объекта"
                    >
                        <div class="common-ckeditor">
                            <h1>Галерея фотографий</h1>
                        </div>

                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _desktop" style="height: 40px"></div>
                        </plugin-spacer>
                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _mobile" style="height: 20px"></div>
                        </plugin-spacer>

                        <plugin-gallery
                            v-bind:slides="[
            {
                image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_1.jpg',
                caption: 'Рендер 1',
            },
            {
                image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_2.jpg',
                caption: 'Рендер 2',
            },
            {
                image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_3.jpg',
                caption: 'Рендер 3',
            },
            {
                image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%A4%D0%BE%D1%82%D0%BE%D0%B3%D1%80%D0%B0%D1%84%D0%B8%D1%8F_4.jpg',

            },
            {
                image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_5.jpg',
                caption: 'Рендер 5',
            },
            {
                image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_6.jpg',
                caption: 'Рендер 6',
            },
            {
                image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_7.png',
                caption: 'Рендер 7',
            },
            {
                image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_8.png',
                caption: 'Рендер 8',
            },
            {
                image: 'https://cdn.simpleestate.ru/plugins/gallery/4.png',
                caption: 'Ремонт (рендер 1)',
            },
            {
                image: 'https://cdn.simpleestate.ru/plugins/gallery/6.png',
                caption: 'Ремонт (рендер 2)',
            },
            {
                image: 'https://cdn.simpleestate.ru/plugins/gallery/7.png',
                caption: 'Ремонт (рендер 3)',
            },
            {
                image: 'https://cdn.simpleestate.ru/plugins/gallery/8.png',
                caption: 'Ремонт (рендер 4)',
            },
    ]"
                        >
                            <section class="plugin-gallery">
                                <div class="swiper-container"
                                     ref="plugin-gallery-slider"
                                >
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_1.jpg"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>

                                            <div class="plugin-gallery__item-caption">
                                                Рендер 1
                                            </div>
                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_2.jpg"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>

                                            <div class="plugin-gallery__item-caption">
                                                Рендер 2
                                            </div>
                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_3.jpg"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>

                                            <div class="plugin-gallery__item-caption">
                                                Рендер 3
                                            </div>
                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%A4%D0%BE%D1%82%D0%BE%D0%B3%D1%80%D0%B0%D1%84%D0%B8%D1%8F_4.jpg"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_5.jpg"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>

                                            <div class="plugin-gallery__item-caption">
                                                Рендер 5
                                            </div>
                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_6.jpg"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>

                                            <div class="plugin-gallery__item-caption">
                                                Рендер 6
                                            </div>
                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_7.png"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>

                                            <div class="plugin-gallery__item-caption">
                                                Рендер 7
                                            </div>
                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%A0%D0%B5%D0%BD%D0%B4%D0%B5%D1%80_8.png"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>

                                            <div class="plugin-gallery__item-caption">
                                                Рендер 8
                                            </div>
                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/4.png"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>

                                            <div class="plugin-gallery__item-caption">
                                                Ремонт (рендер 1)
                                            </div>

                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/6.png"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>

                                            <div class="plugin-gallery__item-caption">
                                                Ремонт (рендер 2)
                                            </div>

                                        </div>




                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/7.png"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>

                                            <div class="plugin-gallery__item-caption">
                                                Ремонт (рендер 3)
                                            </div>

                                        </div>




                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/8.png"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>

                                            <div class="plugin-gallery__item-caption">
                                                Ремонт (рендер 4)
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                <div class="plugin-gallery__navigation">
                                    <div class="plugin-gallery__navigation-item _prev"
                                         ref="plugin-gallery-prev"
                                    >
                                        <icon name="chevron-left">
                                        </icon>
                                    </div>
                                    <div class="plugin-gallery__navigation-item _next"
                                         ref="plugin-gallery-next"
                                    >
                                        <icon name="chevron-right">
                                        </icon>
                                    </div>
                                </div>
                                <div class="plugin-gallery__pagination"
                                     ref="plugin-gallery-pagination"
                                >
                                </div>
                            </section>
                        </plugin-gallery>


                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _desktop" style="height: 40px"></div>
                        </plugin-spacer>
                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _mobile" style="height: 20px"></div>
                        </plugin-spacer>

                        <section class="common-columns-36">
                            <section class="common-columns-36__item _common_width_16 _common_offset_0 _sm_width_36 _sm_offset_0">
                                <div class="common-ckeditor">
                                    <h2><strong><span style=""><span style="unicode-bidi: embed;"><span style=""><span
                                        style=""><span style="font-size: 18.0pt;"><span
                                        style='font-family: "Century Gothic";'><span style="color: black;"><span
                                        style="">Качественный актив в отличной локации в правильное время</span></span></span></span></span></span></span></span></strong>
                                    </h2>

                                    <p></p>

                                    <p><span style="font-size: 11.0pt;"><span
                                        style='font-family: "Century Gothic";'><span style="color: black;"><span
                                        style="">Хорошая точка входа в офисный сегмент на фоне накопленного дефицита за последние 10 лет и бурного роста ставок аренды, которые продолжат ежегодный рост в будущем</span></span></span></span>
                                    </p>
                                </div>

                                <plugin-spacer inline-template>
                                    <div class="plugin-spacer _desktop" style="height: 0px"></div>
                                </plugin-spacer>
                                <plugin-spacer inline-template>
                                    <div class="plugin-spacer _mobile" style="height: 20px"></div>
                                </plugin-spacer>
                            </section>

                            <section class="common-columns-36__item _common_width_16 _common_offset_0 _sm_width_36 _sm_offset_0">
                                <div class="common-ckeditor">
                                    <h2><strong><span style=""><span style="unicode-bidi: embed;"><span style=""><span
                                        style=""><span style="font-size: 18.0pt;"><span
                                        style='font-family: "Century Gothic";'><span style="color: black;"><span
                                        style="">Абсолютно новый бизнес-центр класса «A» от MR Group</span></span></span></span></span></span></span></span></strong>
                                    </h2>

                                    <p></p>

                                    <p><span style="font-size: 11.0pt;"><span
                                        style='font-family: "Century Gothic";'><span style="color: black;"><span
                                        style="">Здание, введенное в эксплуатацию в 3 кв. 2025 года, построено по самым современным технологиям для офисов класса «A» от ведущего офисного девелопера MR Group</span></span></span></span>
                                    </p>
                                </div>

                            </section>

                        </section>

                    </div>

                    <div class="plugin-estates-navigable-container__content-item"
                         ref="item2"
                         id="Расположение"
                    >
                        <div class="common-ckeditor">
                            <h1>Расположение</h1>
                        </div>

                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _desktop" style="height: 40px"></div>
                        </plugin-spacer>
                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _mobile" style="height: 20px"></div>
                        </plugin-spacer>

                        <plugin-map inline-template>
                            <article class="plugin-map">
                                <iframe
                                    src="https://yandex.ru/map-widget/v1/?um=constructor%3Ad351a471b9cc45ff218d08c1d2b2f5c91d2a436da2b30a0ee1c098b3645b88c9&amp;source=constructor"
                                    width="500" height="400" frameborder="0"></iframe>
                            </article>
                        </plugin-map>

                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _desktop" style="height: 40px"></div>
                        </plugin-spacer>
                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _mobile" style="height: 20px"></div>
                        </plugin-spacer>
                    </div>
                </div>
                <div class="plugin-estates-navigable-container__menu">
                    <div class="plugin-estates-navigable-container__menu-item">
                        <a class="plugin-estates-navigable-container__menu-item-link"
                           href="#Инвестиционный тезис"
                           v-bind:class="{
                            _active: activeItem === 0
                        }"
                           v-on:click="setActiveItem('Инвестиционный тезис')"
                        >
                            Инвестиционный тезис
                        </a>
                    </div>

                    <div class="plugin-estates-navigable-container__menu-item">
                        <a class="plugin-estates-navigable-container__menu-item-link"
                           href="#Описание объекта"
                           v-bind:class="{
                            _active: activeItem === 1
                        }"
                           v-on:click="setActiveItem('Описание объекта')"
                        >
                            Описание объекта
                        </a>
                    </div>

                    <div class="plugin-estates-navigable-container__menu-item">
                        <a class="plugin-estates-navigable-container__menu-item-link"
                           href="#Расположение"
                           v-bind:class="{
                            _active: activeItem === 2
                        }"
                           v-on:click="setActiveItem('Расположение')"
                        >
                            Расположение
                        </a>
                    </div>

                    <div class="plugin-estates-navigable-container__menu-button">
                        <ui-button
                            v-bind:href="registrationLink"
                            type="button"
                            style="background-color: #20242F"
                            target="_self"
                        >
                            Инвестировать
                        </ui-button>
                    </div>
                </div>
            </article>
        </plugin-estates-navigable-container-finuslugi>
    </page-estates-item-finuslugi>
</template>

<script>
/* eslint-disable */
export default {
    name: 'common-finuslugi-23',
};
</script>

<style scoped lang="less">

</style>
